import { render, staticRenderFns } from "./AlbumCard.vue?vue&type=template&id=12040afc&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"
import style0 from "./AlbumCard.vue?vue&type=style&index=0&id=12040afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12040afc",
  null
  
)

export default component.exports